import React from 'react';

type Props = {
  isLoading: boolean,
  loadingText?: string,
};

const SemiTransparentLoader = ({ isLoading, loadingText = 'Loading' }: Props) => (
  <div className={isLoading ? 'loading' : ''}>
    <div className={isLoading ? 'spinner-wrapper' : ''}>
      <span className={isLoading ? 'spinner-text' : ''}>
        {isLoading ? loadingText.toUpperCase() : ''}
      </span>
      <span className={isLoading ? 'spinner1' : ''} />
    </div>
  </div>
);

export default React.memo(SemiTransparentLoader);

/* <div className={isLoading ? 'search-flight-loading' : ''} /> */



// WEBPACK FOOTER //
// ./src/components/UI/SemiTransparentLoader.js